<template>
  <nav class="ui left fixed vertical menu fuzzy-list">
    <Spinny :promise="usersPromise" />
    <Placy
      v-if="!items.length"
      :promise="usersPromise"
      :empty-message="$t('NO_THING_YET', { thing: $tc('USER', 2) })"
      :error-message="$t('ERR', { action: $t('READ', { thing: $tc('USER', 2) }) })"
    />

    <!-- Search -->
    <div class="item" v-if="items.length > 10">
      <div class="ui icon input">
        <input
          type="text"
          :placeholder="$t('SEARCH')"
          v-model="searchTerm"
          autocomplete="off"
          @keydown.esc="searchTerm = ''"
        />
        <i class="search icon" />
      </div>
    </div>

    <router-link class="item" :to="{ name: 'new-user' }" v-if="$can('create', 'user')">
      <i class="plus icon" />
      <strong>{{ $t('NEW', { thing: $tc('USER', 1) }) }}</strong>
    </router-link>

    <single-user :key="user.original.id" v-for="user in filteredItems" :user="user" />
  </nav>
</template>

<style lang="scss" scoped>
@charset "utf-8";
@import '../../scss/variables';

nav {
  overflow-y: scroll;
}
</style>

<script>
// @flow
import { Spinny, Placy } from 'ui'
import { User } from 'services'
import SingleUser from './SingleUser'
import FuzzyFilterer from '../Mixins/FuzzyFilterer'

export default {
  name: 'user-list',
  components: { Spinny, Placy, SingleUser },
  mixins: [FuzzyFilterer],

  data() {
    return {
      usersPromise: null
    }
  },

  computed: {
    items() {
      return this.$store.state.user.items
    }
  },

  created() {
    this.usersPromise = User.readAllUsers()
  }
}
</script>
